import { C } from '../lib/theme';
import { styles } from '../lib/styles';

// H-2: every paged queue list renders the server's filtered `total` with
// Previous/Next controls — staff can always tell when a list is a window
// onto a larger population ("Showing 51–100 of 312") instead of silently
// seeing the most recent rows.
export function PagingControls({ offset, limit, total, count, onOffset, label = 'cases' }: {
  offset: number;
  limit: number;
  total: number;
  /** Rows actually rendered on this page (after any local re-filtering). */
  count: number;
  onOffset: (offset: number) => void;
  label?: string;
}) {
  if (total === 0) return null;
  const from = offset + 1;
  const to = offset + count;
  const showRange = total > limit || offset > 0;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 12 }}>
      <span style={{ fontSize: 12, color: C.textMuted }}>
        {showRange ? `Showing ${from}–${to} of ${total} ${label}` : `Showing all ${total} ${label}`}
      </span>
      {showRange && (
        <span style={{ display: 'flex', gap: 8 }}>
          <button
            type="button"
            style={{ ...styles.btn, ...styles.btnOutline, ...styles.btnSmall, ...(offset === 0 ? { opacity: 0.5, cursor: 'default' } : {}) }}
            disabled={offset === 0}
            onClick={() => onOffset(Math.max(0, offset - limit))}
          >
            ← Previous
          </button>
          <button
            type="button"
            style={{ ...styles.btn, ...styles.btnOutline, ...styles.btnSmall, ...(offset + limit >= total ? { opacity: 0.5, cursor: 'default' } : {}) }}
            disabled={offset + limit >= total}
            onClick={() => onOffset(offset + limit)}
          >
            Next →
          </button>
        </span>
      )}
    </div>
  );
}
